import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
    *{
        box-sizing:border-box;
        text-align:center;
        
    }
    body{
        font-family: 'Rubik', sans-serif;
        margin:0;
        padding:0
        
    }
 
`

export default GlobalStyles;

